<script setup>
// NOTICE: KAPTION-INTEGRATION - Toggle to default sidebar to All Conversations instead of My Inbox
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { default_all_conversations } = currentAccount.value?.settings || {};
    isEnabled.value = !!default_all_conversations;
  },
  { deep: true, immediate: true }
);

const updateAccountSettings = async settings => {
  try {
    await updateAccount(settings);
    useAlert(t('GENERAL_SETTINGS.FORM.DEFAULT_ALL_CONVERSATIONS.API.SUCCESS'));
  } catch (error) {
    useAlert(t('GENERAL_SETTINGS.FORM.DEFAULT_ALL_CONVERSATIONS.API.ERROR'));
  }
};

const toggleDefaultAllConversations = async () => {
  return updateAccountSettings({
    default_all_conversations: isEnabled.value,
  });
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.DEFAULT_ALL_CONVERSATIONS.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.DEFAULT_ALL_CONVERSATIONS.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleDefaultAllConversations" />
      </div>
    </template>
  </SectionLayout>
</template>
